import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { PassengerInformationInputModalFooterComponent } from '@app/my-booking/sub-components/passenger-information-input-modal/passenger-information-input-modal-footer.component';
import { PassengerInformationInputModalHeaderComponent } from '@app/my-booking/sub-components/passenger-information-input-modal/passenger-information-input-modal-header.component';
import { PassengerInformationInputModalComponent } from '@app/my-booking/sub-components/passenger-information-input-modal/passenger-information-input-modal.component';
import {
  isEmptyArray,
  isEmptyObject,
  isStringEmpty,
  navigateToAnotherApp,
  parseEmptyArray,
  stringEmptyDefault,
} from '@common/helpers';
import { FEATURE_TO_ROUTE_MAPPING } from '@common/helpers/constants/servicing.contant';
import { MyBookingTabShow } from '@common/helpers/enums/servicing.enum';
import { MNdcOffice } from '@common/interfaces/master/m_ndc_office';
import { OfficeByOffceCodeInfo } from '@common/interfaces/master/office_by offce_code';
import {
  INITIAL_MYBOOKING_MASTER_DATA,
  IOfflineOfficeCityCode,
  MasterDataS01P030,
  PaidDivisionStatus,
} from '@common/interfaces/mybooking/mybooking.interface';
import { LOAD_MASTERS } from '@common/master';
import { MasterJsonKeyPrefix, MasterStoreKey } from '@conf/asw-master.config';
import { SERVICING_ROUTES } from '@conf/routes.config';
import { environment } from '@env/environment';
import { AmcLoginHeaderComponent } from '@lib/components/shared-ui-components/amc-login/amc-login-header.component';
import { AmcLoginComponent } from '@lib/components/shared-ui-components/amc-login/amc-login.component';
import { ModalType } from '@lib/components/shared-ui-components/modal/modal.state';
import { AlertType, ErrorType, LoginStatusType, MOffice } from '@lib/interfaces';
import { ApiErrorResponseModel } from '@lib/interfaces/api-error-response';
import { AswContextModel } from '@lib/interfaces/asw-context';
import { BookingType } from '@lib/interfaces/booking-type';
import { DialogClickType } from '@lib/interfaces/dialog';
import { PageType } from '@lib/interfaces/page';
import { SessionStorageName } from '@lib/interfaces/session-storage-name';
import { CommonLibService } from '@lib/services/common-lib/common-lib.service';
import { DialogDisplayService } from '@lib/services/dialog-display/dialog-display.service';
import { ErrorsHandlerService } from '@lib/services/errors-handler/errors-handler.service';
import { ModalService } from '@lib/services/modal/modal.service';
import { PageLoadingService } from '@lib/services/page-loading/page-loading.service';
import { BehaviorSubject, Observable, Subject, firstValueFrom, take } from 'rxjs';
import { ExchangeApiService } from 'src/sdk-exchange';
import {
  Bound,
  GetOrderResponseData,
  GetOrderResponseDataAir,
  GetOrderResponseDataOrderEligibilitiesChange,
  GetOrderResponseDataOrderType,
} from 'src/sdk-servicing';
import { navigateAnotherMethodPost } from '../next-action/next-action.helpers';
import { ServicingCommonStoreService } from '../servicing-common-store/servicing-common-store.service';
import { MyBookingServiceService } from './my-booking-service/my-booking-service.service';
import { MyBookingStoreService } from './my-booking-store.service';
import { ErrorCodeConstants } from '@conf/app.constants';

@Injectable({
  providedIn: 'root',
})
export class MyBookingService {
  /** 予約詳細表示タブ */
  tabShow = '';
  tabActive = '';
  /** 遷移元機能ID */
  transitionSourceFunctionId = '';
  /** 遷移元画面ID */
  transitionSourcePageId = '';
  /** 初回表示フラグ */
  isFirstDisplay = false;
  /** 登録完了時機能種別変数 */
  completedFunction = '';
  /** PNR情報取得API処理フラグ変数 */
  private _PNRInfomationAquisitionFlag = false;

  /** 再表示フラグ */
  refreshFlag = false;
  // check if user click 他予約検索ボタン押下処理
  isLoadStateClickSearchMenu = false;

  _closeModal = new BehaviorSubject<boolean>(false);
  _closeModal$ = this._closeModal.asObservable();

  private _apiFareConditionSubject = new Subject();
  private _hadFareCondition = false;

  private readonly _onInitSubject = new BehaviorSubject(1);
  private readonly _onInitFinishedSubject = new BehaviorSubject(false);

  positionScrollId$ = new BehaviorSubject('');
  isApiCallMyBookingCompleted$ = new BehaviorSubject(false);
  myBookingMasterData$ = new BehaviorSubject<MasterDataS01P030>(INITIAL_MYBOOKING_MASTER_DATA);
  /** NOTE: used as class's method for UT purpose */
  navigateToAnotherApp;
  navigateAnotherMethodPost;
  constructor(
    private readonly _modalService: ModalService,
    private readonly _errorsHandlerSvc: ErrorsHandlerService,
    private readonly _dialogService: DialogDisplayService,
    private readonly _myBookingStoreService: MyBookingStoreService,
    private readonly _myBookingServiceService: MyBookingServiceService,
    private readonly _common: CommonLibService,
    private readonly _router: Router,
    private readonly _servicingCommonStoreService: ServicingCommonStoreService,
    private readonly exchangeApiService: ExchangeApiService,
    private readonly _loadingSvc: PageLoadingService
  ) {
    this.navigateToAnotherApp = navigateToAnotherApp;
    this.navigateAnotherMethodPost = navigateAnotherMethodPost;
  }

  get PNRInfomationAquisitionFlag() {
    return this._PNRInfomationAquisitionFlag;
  }

  set PNRInfomationAquisitionFlag(PNRInfomationAquisitionFlag: boolean) {
    this._hadFareCondition = !PNRInfomationAquisitionFlag;
    this._PNRInfomationAquisitionFlag = PNRInfomationAquisitionFlag;
  }

  // Call Event (1)
  runOnInit() {
    this._onInitFinishedSubject.next(false);
    this._onInitSubject.next(this._onInitSubject.value + 1);
  }

  finishInit() {
    this._onInitFinishedSubject.next(true);
  }

  get onInitSubject() {
    return this._onInitSubject;
  }

  get onInitFinishedSubject() {
    return this._onInitFinishedSubject;
  }

  get apiGetFareConditionSubject() {
    return this._hadFareCondition ? new BehaviorSubject(1) : this._apiFareConditionSubject;
  }

  get hadFareCondition() {
    return this._hadFareCondition;
  }

  completeFareConditionApiCall() {
    this._hadFareCondition = true;
    this._apiFareConditionSubject.next(1);
  }

  /** 遷移元機能ID-遷移元画面ID */
  getTransitionSourceFullFunctionPageId() {
    return `${this.transitionSourceFunctionId}-${this.transitionSourcePageId}`;
  }

  getFilteredDB<T>(db: Array<T>, funcFilter: (item: T) => boolean) {
    return db?.filter?.(funcFilter)?.at(0);
  }

  openDialogPromise(message: string): Promise<DialogClickType> {
    return new Promise((resolve) => {
      this._dialogService
        .openDialog({ message: message })
        .buttonClick$.subscribe((result) => resolve(result.clickType));
    });
  }

  getAddReservation(): Observable<boolean> {
    return this._closeModal$;
  }

  setAddReservation(value: boolean) {
    return this._closeModal.next(value);
  }

  getDynamicMessage(messageId: string) {
    return MasterJsonKeyPrefix.DYNAMIC + messageId;
  }

  getConnectionKind() {
    const offices: MOffice[] = this._common.aswMasterService.aswMaster[MasterStoreKey.OFFICE_ALL] ?? [];
    const CONNECTION_KIND =
      offices.find((office) => office.office_code === this._common.aswContextStoreService.aswContextData.pointOfSaleId)
        ?.connection_kind ?? '';

    return CONNECTION_KIND;
  }

  /** (共通No.1) 表示タブ切り替え処理 _1 */
  async onHandleCommonNo1() {
    if (
      // 1.	サービシング共通store.予約詳細表示タブ="service"(予約詳細(サービス))かつ、
      this._servicingCommonStoreService.servicingCommon.tabShow === MyBookingTabShow.MyBookingTabShowEnum.Service &&
      // 予約詳細表示タブ変数="itinerary"(予約詳細(旅程))または"traveler"(予約詳細(搭乗者))の場合、
      (this.tabShow === MyBookingTabShow.MyBookingTabShowEnum.Itinerary ||
        this.tabShow === MyBookingTabShow.MyBookingTabShowEnum.Traveler)
    ) {
      // 予約詳細(サービス)(S01-P033)の[申込操作中情報有無判定処理]を呼び出し、返却値の申込操作中有無を確認する。
      const result = this._myBookingServiceService.onHandleCommonNo2();
      // 1.1.	申込操作中有無=true(申込操作中)の場合、
      if (result) {
        // パラメータとして"MSG0524"(選択された内容が無効となる旨)を設定し、確認ダイアログ(G02-005)を呼び出し、表示する。
        const resultModal = await this.openDialogPromise(this.getDynamicMessage('MSG0524'));
        // 1.1.2.	確認ダイアログより確定ボタン押下が返却された場合、
        if (resultModal === DialogClickType.CONFIRM) {
          // 予約詳細(サービス)(S01-P033)の[全サービスの編集情報破棄処理]を実施し、以降の処理を行う。
          this._myBookingServiceService.onHandleCommonNo3();
          // call handleChangeTab in if flow
          this.handleChangeTab(this.tabShow);
        } else {
          // 1.1.1.	確認ダイアログより閉じるボタン押下が返却された場合、当処理を終了する。
          return;
        }
      }
    }
    this.handleChangeTab(this.tabShow);
  }

  /** (共通No.1) 表示タブ切り替え処理 _2 */
  handleChangeTab(tabShow: string) {
    // 2.	サービシング共通store.予約詳細表示タブに予約詳細表示タブ変数を設定する。
    this._servicingCommonStoreService.updateServicingCommon({
      tabShow,
    });
    if (
      // 3.	予約詳細表示タブ変数="itinerary"(予約詳細(旅程))の場合、
      tabShow === MyBookingTabShow.MyBookingTabShowEnum.Itinerary ||
      // 4.	予約詳細表示タブ変数="traveler"(予約詳細(搭乗者))の場合、
      tabShow === MyBookingTabShow.MyBookingTabShowEnum.Traveler
    ) {
      // 3.1.	サービシング共通store.初期表示サービスに""(空欄)を設定する。
      // 4.1.	サービシング共通store.初期表示サービスに""(空欄)を設定する。
      this._servicingCommonStoreService.updateServicingCommon({
        initDisplayService: '',
      });
    }
    // 3.2.	予約詳細(旅程)(S01-P031)の初期表示処理に記載の処理を行う。
    // 4.2.	予約詳細(搭乗者)(S01-P032)の初期表示処理に記載の処理を行う。
    // 5.	予約詳細表示タブ変数="service"(予約詳細(サービス))の場合、予約詳細(サービス)(S01-P033)の初期表示処理に記載の処理を行う。
    // Open tab, run init
    this.tabActive = tabShow;
  }

  /** (共通No.2) 利用不可理由に応じたエラーメッセージ表示処理 */
  onHandleCommonNo2(func: string, aswImpossible: Array<string> = [], dxAPIReason = '') {
    // 1.	以下条件で「機能不可事由」テーブルからエラーメッセージIDを取得する。
    const result =
      this.myBookingMasterData$.value.mFucntionIneligibleReason?.[String(func)]?.[String(aswImpossible?.[0])]?.[
        String(dxAPIReason)
      ];
    // 2.	機能不可事由.エラーメッセージIDが存在する場合、
    if (result?.[0]?.error_message_id) {
      // 継続可能なエラー情報を指定し、当画面にてエラーメッセージの表示を行い、処理を終了する。
      this._errorsHandlerSvc.setRetryableError(PageType.PAGE, {
        errorMsgId: result[0].error_message_id,
      });
    }
    // 3.	機能不可事由.エラーメッセージIDが存在しない場合、
    else {
      // 指定した機能が利用不可である旨の継続可能なエラー情報を指定し、当画面にてエラーメッセージの表示を行い、処理を終了する。
      this._errorsHandlerSvc.setRetryableError(PageType.PAGE, {
        errorMsgId: 'E0765',
      });
    }
  }

  /** (共通No.3) 搭乗者情報入力モーダル表示処理 */
  async onHandleCommonNo3() {
    // 1.	[当画面共通処理No4.予約詳細store項目削除処理]を行う。
    this.onHandleCommonNo4();
    // 2.	予約詳細表示タブ変数に”traveler”(予約詳細(搭乗者))を設定する。
    this.tabShow = MyBookingTabShow.MyBookingTabShowEnum.Traveler;
    // 3.	[当画面共通処理No1.表示タブ切り替え処理]を行う。
    this.onHandleCommonNo1();

    // 4.	画面表示内容、画面を再表示する。

    // 5.	搭乗者情報入力モーダル表示状態をstoreで管理し、表示する旨を通知することによって搭乗者情報入力(S04-M010)をモーダル表示する。
    this._modalService.showSubPageModal({
      id: 'S04-M010',
      closeBackEnable: true,
      type: ModalType.TYPE8,
      content: PassengerInformationInputModalComponent,
      header: PassengerInformationInputModalHeaderComponent,
      footer: PassengerInformationInputModalFooterComponent,
    });
  }

  /** (共通No.4) 予約詳細Store項目削除処理 */
  onHandleCommonNo4() {
    this._servicingCommonStoreService.updateServicingCommon({
      // 1.	サービシング共通store.登録完了時機能種別に""(空欄)を設定する。
      completedFunction: '',
      // 3.	サービシング共通store.初回表示フラグにfalseを設定する。
      isFirstDisplay: false,
      // 4.	サービシング共通store.初期表示サービスに""(空欄)を設定する。
      initDisplayService: '',
      // 5.	サービシング共通.DxAPIリトリーブ要否フラグ = falseを設定する
      dxApiRetrieveFlg: false,
    });
  }

  /** (共通No.5) 解約エラーメッセージID取得処理 */
  onHandleCommonNo5(pnr: GetOrderResponseData = {}) {
    // PNR情報取得API応答.data.orderEligibilities.cancel.isEligible=false(利用不可)の場合、利用不可理由に対応するエラーメッセージIDの取得を行う。
    if (pnr.orderEligibilities?.cancel?.isEligible === false) {
      // 以下パラメータで「当画面共通処理No2.利用不可理由に応じたエラーメッセージ表示処理」を実施する。
      return this.onHandleCommonNo2('cancel', pnr.orderEligibilities.cancel.nonEligibilityReasons, '-');
    }
  }

  handleGetOrderPostErrorMessage(params: {
    apiErrorCode: string;
    isFromList: boolean;
    aswIntTransition: boolean;
  }): string | undefined {
    const { apiErrorCode, aswIntTransition, isFromList } = params;

    let errorCodeMap: Record<string, string> = {};
    errorCodeMap = { ...this.ERROR_CODE_MAP_DEFAULT };

    const transitionCodeMap =
      aswIntTransition === false ? this.ERROR_CODE_MAP_TRANSITION_FALSE : this.ERROR_CODE_MAP_TRANSTION_TRUE;
    errorCodeMap = { ...errorCodeMap, ...transitionCodeMap };

    if (isFromList) {
      errorCodeMap = { ...errorCodeMap, ...this.ERROR_CODE_MAP_FROM_LIST };
    }

    return errorCodeMap[apiErrorCode];
  }

  getAnabizOfficeError(pointOfSaleId: string, anabizOfficeValues: string[], pnr?: GetOrderResponseData) {
    /** 提携: 提携用にロジックを修正し、以下の条件を検索エラーとする */
    /** 条件1 (法人サイト)法人サイト以外で発券(決済)したPNR */
    // PNR情報取得API応答.data.orderType.isBusinessTripBooking = false(法人PNRでない)、かつ
    // PNR情報取得API応答.data.orderStatus = "ticketed"(発券済)
    const condition1 =
      pnr?.orderType?.isBusinessTripBooking === false &&
      pnr?.orderStatus === GetOrderResponseData.OrderStatusEnum.Ticketed;
    /** 条件2 (法人サイト)法人サイト以外で作成した未発券(未決済)PNRで、運賃が法人サイトで取り扱いのない運賃 */
    // PNR情報取得API応答.data.orderType.isBusinessTripBooking = false(法人PNRでない)、かつ
    // PNR情報取得API応答.data.orderStatus = "unticketed"(未発券) または "unpurchased"(未購入) または "paymentAccepted"(支払受付中) かつ
    // PNR情報取得API応答.data.orderType.isBusinessTripNotAppliableFare = true(法人適用不可運賃)
    const condition2 =
      pnr?.orderType?.isBusinessTripBooking === false &&
      (pnr?.orderStatus === GetOrderResponseData.OrderStatusEnum.Unpurchased ||
        pnr?.orderStatus === GetOrderResponseData.OrderStatusEnum.Unticketed ||
        pnr?.orderStatus === GetOrderResponseData.OrderStatusEnum.PaymentAccepted) &&
      pnr?.orderType?.isBusinessTripNotAppliableFare === true;
    /** 条件3 (個札サイト)法人サイトで作成した未発券(未決済)PNRで、運賃が個札サイトで取り扱いのない運賃 */
    // PNR情報取得API応答.data.orderType.isBusinessTripBooking = true(法人PNRである)、かつ
    // PNR情報取得API応答.data.orderStatus = "unpurchased"(未購入) または "unticketed"(未発券) または "applyingForTicketing(発券申請中)
    // PNR情報取得API応答.data.isBusinessTripFare = true(法人専用運賃である)
    const condition3 =
      pnr?.orderType?.isBusinessTripBooking === true &&
      (pnr?.orderStatus === GetOrderResponseData.OrderStatusEnum.Unpurchased ||
        pnr?.orderStatus === GetOrderResponseData.OrderStatusEnum.Unticketed ||
        pnr?.orderStatus === GetOrderResponseData.OrderStatusEnum.ApplyingForTicketing) &&
      pnr?.orderType?.isBusinessTripFare === true;

    // 8.2.	ユーザ共通情報.操作オフィスコード = 取得した法人オフィス、かつ以下のいずれかの条件に該当する場合、
    if (anabizOfficeValues.includes(pointOfSaleId) && (condition1 || condition2)) {
      // 個札PNRを表示するためには"E1137"(一度法人をログアウトする必要がある旨)を指定する。
      return 'E1137';
    }

    // 8.3.	ユーザ共通情報.操作オフィスコード≠ 取得した法人オフィス、かつ以下の条件すべてを満たす場合、
    if (!anabizOfficeValues.includes(pointOfSaleId) && condition3) {
      // "E1138"(法人専用運賃のため表示ができない予約である旨)を指定する。
      return 'E1138';
    }

    return '';
  }

  getDepartureDate(bounds?: Bound[]) {
    for (const bound of parseEmptyArray(bounds)) {
      for (const flight of parseEmptyArray(bound?.flights)) {
        // 10.1.2.2.3.	PNR情報取得API応答.data.air.bounds.flightsの中に、 最初のisOpenSegment=falseであるflight.departure.dateTimeを取得し、出発日とする。
        if (flight?.isOpenSegment === false) {
          return flight?.departure?.dateTime;
        }
      }
    }
    return null;
  }

  getPNRTypeAndPaidInternalCategory(pnr?: GetOrderResponseData): [BookingType, PaidDivisionStatus.PaidDivisionEnum] {
    /** PNR種別 */
    let pnrType: BookingType;
    let paidInternalCategory: PaidDivisionStatus.PaidDivisionEnum = PaidDivisionStatus.PaidDivisionEnum.Empty;
    // 10.1.2.2.	上記以外の場合、以下の処理を行う。
    // 10.1.2.2.1.	PNR種別に"R"(有償)を設定する。
    pnrType = BookingType.R;
    // 10.1.2.2.2.	以下の条件でASWDB(マスタ)のプロパティを取得する。取得したプロパティ.valueを移行日付(yyyy-MM-dd'T'HH:mm:ss形式)とする。
    /** 移行日付 */
    const transitionDateStr = this._common.aswMasterService.getMPropertyByKey(
      'migration',
      'uiuxs2.transitionDate.domesticDcs'
    );
    // 10.1.2.2.3.	PNR情報取得API応答.data.air.bounds.flightsの中に、 最初のisOpenSegment=falseであるflight.departure.dateTimeを取得し、出発日とする。
    const departureDate = this.getDepartureDate(pnr?.air?.bounds);
    // 10.1.2.2.4.	取得した出発日=""(空欄)の場合、出発日=移行日付を設定する。
    const realDepartureDate = departureDate ? departureDate : transitionDateStr;

    const originDepartureDateTime = realDepartureDate ? new Date(realDepartureDate).getTime() : 0;
    const transitionDate = transitionDateStr ? new Date(transitionDateStr).getTime() : 0;
    // 10.1.2.2.5.	PNR情報取得API応答.data.air.tripType = "domestic"(日本国内単独旅程) かつ
    // 取得した出発日(yyyy-MM-dd'T'HH:mm:ss形式)  ≧ 取得した移行日付の場合、
    // 有償内際区分に"0"(有償国内)を設定する。
    paidInternalCategory = PaidDivisionStatus.PaidDivisionEnum.Domestic;

    return [pnrType, paidInternalCategory];
  }

  async getRedicrectOfficeObject(
    aswContext: AswContextModel,
    anabizOfficeCodes: string[],
    PNR_type: BookingType,
    paidInternalCategory: PaidDivisionStatus.PaidDivisionEnum,
    pnr?: GetOrderResponseData
  ) {
    let afterRedirectOffice: OfficeByOffceCodeInfo | undefined;
    /**
     * 1.有償内際区分="0"(有償国内)の場合、オフィスコードの末尾="DD"
     * 2.有償内際区分="1"(有償国際)の場合、オフィスコードの末尾="AA"
     */
    let officeSuffixCompare = '';

    if (paidInternalCategory === PaidDivisionStatus.PaidDivisionEnum.Domestic) {
      officeSuffixCompare = 'DD';
    }

    if (paidInternalCategory === PaidDivisionStatus.PaidDivisionEnum.International) {
      officeSuffixCompare = 'AA';
    }

    /** 10.1.3.	切り替え先オフィスを取得する。*/
    /** 10.1.3.1 ユーザ共通情報.操作オフィスコード= 取得したANA Bizオフィスの場合、*/
    if (anabizOfficeCodes.includes(aswContext?.pointOfSaleId)) {
      /**
       * 以下の条件でASWDB(マスタ)のオフィスを取得する。(取得結果をリダイレクト後操作オフィス情報に設定する。)
       * テーブル: オフィス
       * キャッシュキー: オフィス_オフィスコード
       * キャッシュ作成条件: なし
       * 検索条件: オフィスコード = ユーザ共通情報.操作オフィスコード
       * ソート順: -
       */
      afterRedirectOffice = this.myBookingMasterData$.value.officeByOffceCode?.find(
        (office) => office.office_code === aswContext?.pointOfSaleId
      );
    }
    // 10.1.3.2.	PNR情報取得API応答.data.orderType.isBusinessTripBooking = true(ANA Biz PNRである)の場合、 PNR情報取得API応答.data.orderStatus = "ticketed"(発券済) の場合、オフィスコードに取得したANA Bizオフィスを設定する。
    else if (
      pnr?.orderType?.isBusinessTripBooking === true &&
      pnr?.orderStatus === GetOrderResponseData.OrderStatusEnum.Ticketed
    ) {
      /**
       * 以下の条件でASWDB(マスタ)のオフィスを取得する。(取得結果をリダイレクト後操作オフィス情報に設定する。)
       * テーブル: オフィス
       * キャッシュキー: オフィス_オフィスコード
       * キャッシュ作成条件: なし
       * オフィスコード = 取得したANA Bizオフィス
       * ソート順: -
       */
      afterRedirectOffice = this.myBookingMasterData$.value.officeByOffceCode?.find(
        (office) => office?.office_code && anabizOfficeCodes.includes(office.office_code)
      );
    }

    // 10.1.3.3. PNR情報取得API応答.data.orderType.channelDetail = "asw"(ASW作成PNR)の場合、以下の処理を行う。
    else if (pnr?.orderType?.channelDetail === GetOrderResponseDataOrderType.ChannelDetailEnum.Asw) {
      // 10.1.3.3.1.PNR情報取得API応答.data.servicingPointOfSale.pointOfSaleId=取得したANA Bizオフィスの場合、
      if (anabizOfficeCodes.includes(pnr?.servicingPointOfSale?.pointOfSaleId!)) {
        /**
         * 以下の条件でASWDB(マスタ)のオフィスを取得する。(取得結果をリダイレクト後操作オフィス情報に設定する。)
         * テーブル: オフィス
         * キャッシュキー: オフィス_オフィスコード
         * キャッシュ作成条件: なし
         * 検索条件: POS国コード = "JP"  AND
         *          AND ダミーオフィスフラグ ≠ true(ダミーオフィス)
         *          AND 有償特典区分 =  上記で設定したPNR種別 AND
         *          1.有償内際区分="0"(有償国内)の場合、オフィスコードの末尾="DD"
         *          2.有償内際区分="1"(有償国際)の場合、オフィスコードの末尾="AA"
         * ソート順: -
         */
        afterRedirectOffice = this.myBookingMasterData$.value.officeByOffceCode?.find((office) => {
          const doesMatchSuffix = office.office_code?.slice(-2) === officeSuffixCompare;
          return (
            office.pos_country_code === 'JP' &&
            office.dummy_office_flag !== true &&
            office.booking_type === PNR_type &&
            doesMatchSuffix
          );
        });
      }
      // 10.1.3.3.2. 上記以外の場合、オフィスコードにPNR情報取得API応答.data.servicingPointOfSale.pointOfSaleIdを設定する。
      else {
        /**
         * 以下の条件でASWDB(マスタ)のオフィスを取得する。(取得結果をリダイレクト後操作オフィス情報に設定する。)
         * テーブル: オフィス
         * キャッシュキー: オフィス_オフィスコード
         * キャッシュ作成条件: なし
         * 検索条件: オフィスコード = 設定したオフィスコード
         * ソート順: -
         */
        afterRedirectOffice = this.myBookingMasterData$.value.officeByOffceCode?.find(
          (office) => office.office_code === pnr?.servicingPointOfSale?.pointOfSaleId
        );
      }
    }
    // 10.1.3.4.	上記以外の場合、以下の処理を行う。
    else {
      // 10.1.3.4.1.	PNR情報取得API応答.data.orderType.channelDetail = "callCenter"(コールセンター作成PNR)の場合、以下の処理を行う。
      if (pnr?.orderType?.channelDetail === GetOrderResponseDataOrderType.ChannelDetailEnum.CallCenter) {
        const offlineOffices_db: Record<string, IOfflineOfficeCityCode[]> = await firstValueFrom(
          this._common.aswMasterService.getAswMasterByKey$(LOAD_MASTERS.OFFLINEOFFICE_CITYCODE.key)
        );
        // 10.1.3.4.1.1.	以下の条件でASWDB(マスタ)のオフラインオフィスを取得する。
        const threeCharacter = stringEmptyDefault(pnr?.servicingPointOfSale?.pointOfSaleId).substring(0, 3);
        const offlineOffice = offlineOffices_db?.[threeCharacter]?.[0];

        // 10.1.3.4.1.2.	以下の条件でASWDB(マスタ)のオフィスを取得する。
        afterRedirectOffice = (this.myBookingMasterData$.value.officeByOffceCode ?? []).find((office) => {
          const doesMatchSuffix = office.office_code?.slice(-2) === officeSuffixCompare;

          return (
            office.pos_country_code === offlineOffice?.pos_country_code &&
            office.dummy_office_flag === false &&
            office.booking_type === PNR_type &&
            doesMatchSuffix
          );
        });
      }

      // 10.1.3.4.2.	PNR情報取得API応答.data.orderType.channelType = "ndc"(NDC PNR)の場合
      if (pnr?.orderType?.channelType === GetOrderResponseDataOrderType.ChannelTypeEnum.Ndc) {
        // 10.1.3.4.2.1.	以下の条件でASWDB(マスタ)のNDCオフィスを取得する。
        const ndc_office = this.getFilteredDB<MNdcOffice>(
          this.myBookingMasterData$.value.mNdcOffice ?? [],
          (office) => office.ndc_office_code === pnr?.servicingPointOfSale?.pointOfSaleId
        );

        // 背景運用サイドからSPAアプリ内でマスタからデータを取得する際に、値が存在しなかったら運用確認ログで確認をしたいという依頼がありました。

        if (isEmptyObject(ndc_office)) {
          this._common.loggerDatadogService.operationConfirmLog('MST0003', {
            0: LOAD_MASTERS.M_NDC_OFFICE.key,
            1: stringEmptyDefault(pnr?.servicingPointOfSale?.pointOfSaleId),
          });
        }

        // 10.1.3.4.2.2.	取得したNDCオフィス.リダイレクト先オフィスコード≠“"(空欄)の場合、
        if (
          !isStringEmpty(ndc_office?.redirect_domestic_office_code) ||
          !isStringEmpty(ndc_office?.redirect_international_office_code)
        ) {
          // 以下の条件でASWDB(マスタ)のオフィスを取得する。(取得結果をリダイレクト後操作オフィス情報に設定する。)
          afterRedirectOffice = this.getFilteredDB<OfficeByOffceCodeInfo>(
            this.myBookingMasterData$.value.officeByOffceCode ?? [],
            (office) =>
              paidInternalCategory === PaidDivisionStatus.PaidDivisionEnum.Domestic
                ? office.office_code === ndc_office?.redirect_domestic_office_code
                : office.office_code === ndc_office?.redirect_international_office_code
          );
        }
      }

      // 10.1.3.4.3.	PNR情報取得API応答.data.orderType.channelType = "nh3"(国内代理店作成PNR)の場合、
      if (pnr?.orderType?.channelType === GetOrderResponseDataOrderType.ChannelTypeEnum.Nh3) {
        // 10.1.3.3.3.1.	以下の条件でASWDB(マスタ)のオフィスを取得する。(取得結果をリダイレクト後操作オフィス情報に設定する。)
        afterRedirectOffice = this.myBookingMasterData$.value.officeByOffceCode?.find((office) => {
          // POS国コード = "JP"(日本)  AND
          // ダミーオフィスフラグ ≠ true(ダミーオフィス) AND
          // 有償特典区分 =  "R"(有償) AND
          // 1.有償内際区分="0"(有償国内)の場合、オフィスコードの末尾="DD"
          // 2.有償内際区分="1"(有償国際)の場合、オフィスコードの末尾="AA"
          const isMatchSuffix = isStringEmpty(officeSuffixCompare)
            ? true
            : stringEmptyDefault(office.office_code).slice(-2) === officeSuffixCompare;
          return (
            office.pos_country_code === 'JP' &&
            !office.dummy_office_flag &&
            office.booking_type === BookingType.R &&
            isMatchSuffix
          );
        });
      }
    }

    // 10.1.3.5.	上記で設定したリダイレクト後操作オフィス情報が""(空欄)場合、以下の条件でASWDB(マスタ)のオフィスを取得する。
    if (!afterRedirectOffice) {
      // (取得結果をリダイレクト後操作オフィス情報に設定する。)
      afterRedirectOffice = this.myBookingMasterData$.value.officeByOffceCode?.find((office) => {
        // POS国コード = ユーザ共通.POS国コード(2レター)  AND
        // ダミーオフィスフラグ ≠ true(ダミーオフィス) AND
        // 有償特典区分 =  上記で設定したPNR種別 AND
        // 1.有償内際区分="0"(有償国内)の場合、オフィスコードの末尾="DD"
        // 2.有償内際区分="1"(有償国際)の場合、オフィスコードの末尾="AA"
        const isMatchSuffix = isStringEmpty(officeSuffixCompare)
          ? true
          : stringEmptyDefault(office.office_code).slice(-2) === officeSuffixCompare;
        return (
          office.pos_country_code === aswContext.posCountryCode &&
          office.dummy_office_flag !== true &&
          office.booking_type === PNR_type &&
          isMatchSuffix
        );
      });
    }

    return afterRedirectOffice;
  }

  /** (27) 搭乗者情報登録ボタン押下処理 */
  onHandlePassengerInformationRegistration(pnr: GetOrderResponseData = {}, closeModal?: Function) {
    // 1.	[当画面共通処理No4.予約詳細store項目削除処理]を行う。
    this.onHandleCommonNo4();
    // 2.	予約詳細表示タブ変数に”traveler”(予約詳細(搭乗者))を設定する。
    this.tabShow = MyBookingTabShow.MyBookingTabShowEnum.Traveler;
    // 3.	[当画面共通処理No1.表示タブ切り替え処理]を行う。
    this.onHandleCommonNo1();
    // 4.	画面表示内容、画面を再表示する。
    // 5.	PNR情報取得API応答.data.orderEligibilities.travelerInput.isEligible = false(利用不可)の場合、以下の処理を行う。
    if (pnr.orderEligibilities?.travelerInput?.isEligible === false) {
      // 5.1.	以下パラメータで「当画面共通処理No2.利用不可理由に応じたエラーメッセージ表示処理」を実施する。
      this.onHandleCommonNo2('travelerInput', pnr.orderEligibilities?.travelerInput?.nonEligibilityReasons, '-');
      // 5.2.	遷移元機能ID="C01"、遷移元画面ID="P030"(チェックイン搭乗者情報入力) の場合、ワーニングメッセージを表示する。
      if (this.getTransitionSourceFullFunctionPageId() === 'C01-P030') {
        this._common.alertMessageStoreService.setAlertWarningMessage({
          contentHtml: 'W0851',
          isCloseEnable: true,
          alertType: AlertType.WARNING,
          errorMessageId: 'W0851',
        });
      }
      // 5.3.	以降の処理を行わない、本処理を中止する。
      closeModal?.();
      return;
    }

    // 6.	搭乗者情報入力モーダル表示状態をstoreで管理し、表示する旨を通知することによって搭乗者情報入力(S04-M010)をモーダル表示する。
    this._modalService.showSubPageModal({
      id: 'S04-M010',
      closeBackEnable: true,
      type: ModalType.TYPE8,
      content: PassengerInformationInputModalComponent,
      header: PassengerInformationInputModalHeaderComponent,
      footer: PassengerInformationInputModalFooterComponent,
    });
  }

  /** (24) 変更ボタン押下処理 */
  onHandleChange(pnr: GetOrderResponseData = {}, closeModal: Function = () => {}) {
    // 1.	予約詳細(サービス)(S01-P033)の[全サービスの編集情報破棄処理]を行う。
    this._myBookingServiceService.onHandleCommonNo3();

    // 2.	PNR情報取得API応答.data.orderType.isAwardBooking=true(特典PNR)の場合、以下の処理を行う。
    if (pnr?.orderType?.isAwardBooking === true) {
      // 2.1.	ユーザ共通.ログインステータス="NOT_LOGIN”(未ログイン)の場合、以下の処理を行う。
      if (this._common.isNotLogin()) {
        // 2.1.1.	ログイン画面モーダル表示状態をstoreで管理し、表示する旨を通知することによってログイン画面(S01-M011)を表示する。
        const _modalLoginParts = this._modalService.defaultIdPart(AmcLoginComponent, AmcLoginHeaderComponent);
        _modalLoginParts.payload = {
          submitEvent: () => this.handleClickChange(pnr),
          // 2.1.2.	ログイン失敗の場合、以降の処理を行わない。
          closeEvent: () => closeModal(),
        };
        this._modalService.showSubPageModal(_modalLoginParts);
      } else {
        this.handleClickChange(pnr);
      }
    }
    // 3.	上記以外の場合、以下処理を行う。
    // 3.1.	PNR情報取得API応答.data.orderEligibilities.change.isEligible=false(利用不可)の場合、利用不可理由に対応するエラーメッセージIDの取得を行う。
    else if (pnr?.orderEligibilities?.change?.isEligible === false) {
      // 以下パラメータで「当画面共通処理No2.利用不可理由に応じたエラーメッセージ表示処理」を実施する。
      const func = 'change';
      const aswImpossible = pnr?.orderEligibilities?.change
        ?.nonEligibilityReasons as Array<GetOrderResponseDataOrderEligibilitiesChange.NonEligibilityReasonsEnum>;
      const dxAPIReason = '-';
      this.onHandleCommonNo2(func, aswImpossible, dxAPIReason);
      closeModal();
    } else {
      // 3.2.	上記以外の場合、フライト検索(E01-P010)へ遷移する。
      this._servicingCommonStoreService.updateServicingCommon({
        getOrder: {},
      });
      this.navigateAnotherMethodPost(environment.spa.app.exc, SERVICING_ROUTES.changeFlightSearch, {
        CONNECTION_KIND: 'ZZZ',
      });
    }
  }

  handleClickChange(_pnr: GetOrderResponseData) {
    const CONNECTION_KIND = this.getConnectionKind();
    // 2.2.	表の項目をパラメータとして保持し、以下条件にて旧ASWの特典機能へ遷移する。
    const params = new URLSearchParams({
      CONNECTION_KIND,
      LANG: this._common.aswContextStoreService.aswContextData.lang,
      identificationId: this._common.loadSessionStorage(SessionStorageName.IDENTIFICATION_ID)!,
      REC_LOC: _pnr?.orderId!,
      passengerFirstName: this._common.aswServiceStoreService.aswServiceData.firstName!,
      passengerLastName: this._common.aswServiceStoreService.aswServiceData.lastName!,
      STATIC: 'STATIC',
    }).toString();

    // 2.2.1.	PNR情報取得API応答.data.orderStatus ≠”ticketed”(発券済み)の場合、以下の処理を行う。
    // 2.2.2.	上記以外の場合、以下の処理を行う。
    const key =
      _pnr?.orderStatus !== GetOrderResponseData.OrderStatusEnum.Ticketed
        ? 'url.internationalAsw.awardUnticketedChangeSearchRoundtripInput'
        : 'url.internationalAsw.awardTicketedChangeSearchRoundtripInput';

    // 2.2.1.1.	以下の条件でASWDBの「プロパティ」テーブルからプロパティ.valueを取得して、特典旅程変更(未発券)のURLとして保持する。
    // 2.2.2.1.	以下の条件でASWDBの「プロパティ」テーブルからプロパティ.valueを取得して、特典旅程変更(発券後)のURLとして保持する。
    const domain = this._common.aswMasterService.getMPropertyByKey('servicing', key);
    const destinationURL = `${domain}?${params}`;
    // 2.2.1.2.	特典旅程変更(未発券)機能の条件入力画面(A05_P01)へ遷移する。
    // 2.2.2.2.	特典旅程変更(発券後)機能の条件入力画面(A06_P01)へ遷移する。
    window.open(destinationURL, '_self');
  }

  /** (25) 解約ボタン押下処理 */
  onHandleCancel(pnr: GetOrderResponseData = {}, closeModal: Function = () => {}) {
    // 1.	予約詳細(サービス)(S01-P033)の[全サービスの編集情報破棄処理]を行う。
    this._myBookingServiceService.onHandleCommonNo3();

    // 2.	PNR情報取得API応答.data.orderType.isAwardBooking=true(特典PNR)かつ、PNR情報取得API応答.data.orderStatus=”ticketed”(発券済み)の場合
    if (pnr.orderType?.isAwardBooking === true && pnr.orderStatus === GetOrderResponseData.OrderStatusEnum.Ticketed) {
      // 2.1.1.	ユーザ共通.ログインステータス="NOT_LOGIN”(未ログイン)の場合、以下の処理を行う。
      // 2.2.1.	ユーザ共通.ログインステータス="NOT_LOGIN”(未ログイン)の場合、以下の処理を行う。
      if (this._common.aswContextStoreService.aswContextData.loginStatus === LoginStatusType.NOT_LOGIN) {
        const _modalLoginParts = this._modalService.defaultIdPart(AmcLoginComponent, AmcLoginHeaderComponent);
        _modalLoginParts.payload = {
          // PNR情報取得API応答.data.prices.isContainedGmopPayment=true(航空券の支払い手段にGMOPが含まれている)の場合、trueとする。  上記以外の場合、falseとする。
          matchesToTraveler: pnr?.prices?.isContainedGmopPayment === true,
          // PNR情報取得API応答.data.orderType.isAwardBooking＝true(特典PNR)の場合、trueとする。  上記以外の場合、falseとする。
          matchesToMileageRedemptionMember: pnr?.orderType?.isAwardBooking === true,
          submitEvent: () => this.onHandleCancelAMCLogin(pnr),
        };
        // 2.1.1.1.	ログイン画面モーダル表示状態をstoreで管理し、表示する旨を通知することによって未ログイン利用可能としてログイン画面(S01-M011)を表示する.
        // 2.2.1.1.	ログイン画面モーダル表示状態をstoreで管理し、表示する旨を通知することによって未ログイン利用可能としてログイン画面(S01-M011)を表示する.
        this._modalService.showSubPageModal(_modalLoginParts);
      } else {
        // 2.1.2.	表の項目をパラメータとして保持し、旧ASWの特典払戻機能(A07_P01)へ遷移する。
        // 2.2.2.	「当画面共通処理.解約エラーメッセージID取得処理」を実施する。
        // 2.2.3.	PNR情報取得API応答.data.orderEligibilities.cancel.isEligible=true(利用可能)の場合、払戻情報入力(E03-P010)に遷移する。
        this.onHandleCancelAMCLogin(pnr);
      }
    }
    // 3.	上記以外の場合
    else {
      // 3.1.	「当画面共通処理No5.解約エラーメッセージID取得処理」を実施する。
      this.onHandleCommonNo5(pnr);
      const isEligible = pnr.orderEligibilities?.cancel?.isEligible === true;
      // 3.2.	PNR情報取得API応答.data.orderStatus=”ticketed”(発券済み)かつ、PNR情報取得API応答.data.orderEligibilities.cancel.isEligible=true(利用可能) の場合
      if (pnr.orderStatus === GetOrderResponseData.OrderStatusEnum.Ticketed && isEligible) {
        // 3.2.1.	サービシング共通storeからPNR情報取得API応答を削除する。
        this._servicingCommonStoreService.updateServicingCommon({
          getOrder: {},
        });
        // 3.2.2.	以下のパラメータを指定しする。
        this.navigateToAnotherApp(environment.spa.app.exc, SERVICING_ROUTES.refundInput, { CONNECTION_KIND: 'ZZZ' });
      }
      // 3.3.	PNR情報取得API応答.data.orderStatus≠”ticketed”(発券済み) かつ、PNR情報取得API応答.data.orderEligibilities.cancel.isEligible=true(利用可能)の場合
      if (pnr.orderStatus !== GetOrderResponseData.OrderStatusEnum.Ticketed && isEligible) {
        const message =
          pnr.serviceSummary?.hasRequested?.keepMyFare === true
            ? // 3.3.1.	PNR情報取得API応答.data.serviceSummary.hasRequested.KeepMyFare=trueの場合、
              this.getDynamicMessage('MSG0497')
            : // 3.3.2.	上記以外の場合、
              this.getDynamicMessage('MSG0393');
        // 3.3.1.1.	以下の条件でASWDBマスタの動的文言テーブルからメッセージを取得し、取得したメッセージを基に確認ダイアログ(G02-005)を表示する。
        // 3.3.2.1.	以下の条件でASWDBマスタの動的文言テーブルからメッセージを取得し、取得したメッセージを基に確認ダイアログ(G02-005)を表示する。
        this._dialogService.openDialog({ message }).buttonClick$.subscribe((result) => {
          if (result.clickType === DialogClickType.CONFIRM) {
            closeModal();
            this.callDeleteOrderApi(pnr);
          } else {
            // 3.3.3.	確認ダイアログより閉じるボタン押下が返却された場合、処理を中断し、以降の処理は行わない。
            closeModal();
          }
        });
      }
    }
  }

  onHandleCancelAMCLogin(pnr: GetOrderResponseData = {}) {
    /**
     * 2.1.	PNR情報取得API応答.data.air.isContainedIrregularFlights = false (イレギュラー便を含まない)
     * かつ PNR情報取得API応答.data.air.isContainedDynamicWaiverRefundFlight = false (Dynamic Waiver Refund対象便を含まない)
     */
    if (pnr.air?.isContainedIrregularFlights === false && pnr.air?.isContainedDynamicWaiverRefundFlight === false) {
      // 2.1.2.	表の項目をパラメータとして保持し、旧ASWの特典払戻機能(A07_P01)へ遷移する。
      const CONNECTION_KIND = this.getConnectionKind();
      const params = new URLSearchParams({
        // オフィスコードに応じてCONNECTION_KINDを取得する。
        CONNECTION_KIND,
        // ユーザー共通情報.言語情報
        LANG: this._common.aswContextStoreService.aswContextData.lang,
        identificationId: this._common.loadSessionStorage(SessionStorageName.IDENTIFICATION_ID)!,
        REC_LOC: pnr?.orderId!,
        passengerLastName: this._common.aswServiceStoreService.aswServiceData.lastName!,
        passengerFirstName: this._common.aswServiceStoreService.aswServiceData.firstName!,
        STATIC: 'STATIC',
      }).toString();
      const domain = this._common.aswMasterService.getMPropertyByKey(
        'servicing',
        'url.internationalAsw.awardRefundReview'
      );
      const destinationURL = `${domain}?${params}`;
      window.open(destinationURL, '_self');
    }
    // 2.2.	上記以外の場合、以下処理を行う
    else {
      // 2.2.2.	「当画面共通処理No5.解 約 エラーメッセージID取得処理」を実施する。
      this.onHandleCommonNo5(pnr);
      // 2.2.3.	PNR情報取得API応答.data.orderEligibilities.cancel.isEligible=true(利用可能)の場合、払戻情報入力(E03-P010)に遷移する。
      if (pnr.orderEligibilities?.cancel?.isEligible === true) {
        // サービシングの場合、サービシング共通storeからPNR情報取得API応答を削除する
        this._servicingCommonStoreService.updateServicingCommon({
          getOrder: {},
        });
        this.navigateToAnotherApp(environment.spa.app.exc, SERVICING_ROUTES.refundInput, { CONNECTION_KIND: 'ZZZ' });
      }
    }
  }

  callDeleteOrderApi(pnr: GetOrderResponseData = {}) {
    this._loadingSvc.startLoading();
    this.exchangeApiService
      .refundOrdersDeleteOrderPost({
        orderId: pnr?.orderId!,
        credential: {
          firstName: this._common.aswServiceStoreService.aswServiceData.firstName!,
          lastName: this._common.aswServiceStoreService.aswServiceData.lastName!,
        },
      })
      .pipe(take(1))
      // 3.3.4.2.	レスポンス情報
      .subscribe({
        // 3.3.4.2.1.	正常終了の場合
        // NOTE: Explain type any: waiting for RefundCompleted page, interfaces
        next: (res: any) => {
          this._loadingSvc.endLoading();
          // 3.3.4.2.1.1.	ワーニング情報が存在する場合、パラメータとしてセッションストレージで保持する。
          if (!isEmptyArray(res.warnings)) {
            sessionStorage.setItem('warningCode', res.warnings?.[0]?.code ?? '');
          }
          // 3.3.4.2.1.2.	サービシング共通storeからPNR情報取得API応答を削除する。
          this._servicingCommonStoreService.updateServicingCommon({
            getOrder: {},
          });
          // 3.3.4.2.1.3.	解約完了画面 (E03-P020)へ遷移する。
          this.navigateAnotherMethodPost(environment.spa.app.exc, FEATURE_TO_ROUTE_MAPPING['E03-P020'], {
            CONNECTION_KIND: 'ZZZ',
          });
        },
        // 3.3.4.2.2.	異常終了の場合
        error: (error) => {
          this.handleErrorRefundDeleteOrder(error);
        },
      });
  }

  handleErrorRefundDeleteOrder(error: ApiErrorResponseModel) {
    this._loadingSvc.endLoading();
    // 以下表の1行目から順に、APIレスポンス.errorsについて、当該error.コード=エラーコードとなるエラーコードが含まれるかを確認し、
    const apiErrorCode = this._common.apiError?.errors?.[0]?.code ?? '';
    const errorMsgId = this.ERROR_CODE_MAP_DEFAULT_REFUND_DELETE_ORDER[apiErrorCode];
    // エラーメッセージIDが存在する場合、以下の情報を設定する。解約ボタン押下処理を終了する。
    // 「共通機能 エラーハンドリング(SPA)(G01-009)」を呼び出し、当処理を終了する。
    if (apiErrorCode && errorMsgId) {
      // 下記の通りに、継続可能なエラー情報を指定し、当モーダルにてエラーメッセージを表示し、解約ボタン押下処理を終了する。
      this._common.errorsHandlerService.setNotRetryableError({
        errorMsgId: errorMsgId,
        errorType: ErrorType.BUSINESS_LOGIC,
        apiErrorCode: apiErrorCode,
      });
    }
  }

  /** (29) 領収書ボタン押下処理 */
  onHandleReceipt(pnr: GetOrderResponseData, closeModal: Function = () => {}) {
    // 1.	予約詳細(サービス)(S01-P033)の[全サービスの編集情報破棄処理]を行う。
    this._myBookingServiceService.onHandleCommonNo3();
    // 2.	PNR情報取得API応答.data.orderEligibilities.receipt.isEligible=false(利用不可)の場合、利用不可理由に対応するエラーメッセージIDの取得を行う。
    if (pnr?.orderEligibilities?.receipt?.isEligible === false) {
      // 以下パラメータで「当画面共通処理No2.利用不可理由に応じたエラーメッセージ表示処理」を実施する。
      this.onHandleCommonNo2('receipt', pnr?.orderEligibilities?.receipt?.nonEligibilityReasons, '-');
      // close modal after handling logic
      closeModal();
    }
    // 3.	上記以外の場合、領収書選択(S05-P011)へ遷移する。
    else {
      this._router.navigate([SERVICING_ROUTES.receiptSelect]);
    }
  }

  /** 7.3.2.1.	以下表のエラーコードは条件を問わず、いずれのエラーコードの行に応じたメッセージを記載する。 */
  readonly ERROR_CODE_MAP_DEFAULT: Record<string, string> = {
    /** "EBAZ000194"(検索時の姓名と一致する搭乗者が存在しない) => "E0399"(入力された名前から予約の特定ができない旨) */
    [ErrorCodeConstants.ERROR_CODES.EBAZ000194]: 'E0399',
    /** "EBAZ000159"(PNRを取得できない) => "E0400"(予約の特定ができない旨) */
    [ErrorCodeConstants.ERROR_CODES.EBAZ000159]: 'E0400',
    /** "EBAZ000367"(複数PNRが返却された) => "E0402"(予約が取り扱いできない為、エラーコードを控え、電話にて問い合わせ頂く旨) */
    [ErrorCodeConstants.ERROR_CODES.EBAZ000367]: 'E0402',
    /** "EBAZ000384"(予約番号検索されたグループPNRである) => "E0415"(情報登録などの操作ができない予約である旨) */
    [ErrorCodeConstants.ERROR_CODES.EBAZ000384]: 'E0415',
    /** "EBAZ000739"(自動Ackに失敗した) => E1739 */
    [ErrorCodeConstants.ERROR_CODES.EBAZ000739]: 'E1739',
    /** "EBAZ000846"(個札PNRを表示するためには一度ANA Bizをログアウトする必要がある) => "E1137"(一度ANA Bizをログアウトする必要がある旨) */
    [ErrorCodeConstants.ERROR_CODES.EBAZ000846]: 'E1137',
    /** "EBAZ000847"(ANA Biz専用運賃のため表示ができない予約である) => "E1138"(ANA Biz専用運賃のため表示ができない予約である旨) */
    [ErrorCodeConstants.ERROR_CODES.EBAZ000847]: 'E1138',
    /** "EBAZ000848"(ANA Bizログイン中の企業精算コード≠発券要求情報の企業精算コード) => "E1858"(ANA Bizログイン中の組織では表示ができない予約である旨) */
    [ErrorCodeConstants.ERROR_CODES.EBAZ000848]: 'E1858',
    /** "EBAZ000843"(上記以外で表示対象セグメントが存在しない) => "E1851"(取り扱い不可の予約である旨) */
    [ErrorCodeConstants.ERROR_CODES.EBAZ000843]: 'E1851',
  };

  /** 7.3.2.2.	予約詳細store.国際ASW内遷移=falseの場合、いずれのエラーコードの行に応じたメッセージを記載する。 */
  readonly ERROR_CODE_MAP_TRANSITION_FALSE: Record<string, string> = {
    [ErrorCodeConstants.ERROR_CODES.EBAZ000189]: 'E0401',
    [ErrorCodeConstants.ERROR_CODES.EBAZ000190]: 'E0401',
    [ErrorCodeConstants.ERROR_CODES.EBAZ000191]: 'E0405',
    [ErrorCodeConstants.ERROR_CODES.EBAZ000192]: 'E0409',
    [ErrorCodeConstants.ERROR_CODES.EBAZ000193]: 'E0401',
    [ErrorCodeConstants.ERROR_CODES.EBAZ000385]: 'E0407',
    [ErrorCodeConstants.ERROR_CODES.EBAZ000638]: 'E0409',
    [ErrorCodeConstants.ERROR_CODES.EBAZ000662]: 'E0409',
  };

  /** 7.3.2.3.	予約詳細store.国際ASW内遷移が存在しない または trueの場合、いずれのエラーコードの行に応じたメッセージを記載する。 */
  readonly ERROR_CODE_MAP_TRANSTION_TRUE: Record<string, string> = {
    [ErrorCodeConstants.ERROR_CODES.EBAZ000189]: 'E0415',
    [ErrorCodeConstants.ERROR_CODES.EBAZ000190]: 'E0415',
    [ErrorCodeConstants.ERROR_CODES.EBAZ000191]: 'E0415',
    [ErrorCodeConstants.ERROR_CODES.EBAZ000192]: 'E0415',
    [ErrorCodeConstants.ERROR_CODES.EBAZ000193]: 'E0415',
    [ErrorCodeConstants.ERROR_CODES.EBAZ000638]: 'E0415',
    [ErrorCodeConstants.ERROR_CODES.EBAZ000662]: 'E0415',
    [ErrorCodeConstants.ERROR_CODES.EBAZ000385]: 'E0407',
  };

  /** 7.3.2.4.	遷移元機能ID-遷移元画面IDが"S01-P020"(予約一覧)の場合、いずれのエラーコードの行に応じたメッセージを記載する。 */
  readonly ERROR_CODE_MAP_FROM_LIST: Record<string, string> = {
    [ErrorCodeConstants.ERROR_CODES.EBAZ000190]: 'E0411',
    [ErrorCodeConstants.ERROR_CODES.EBAZ000385]: 'E0414',
  };

  readonly SCROLL_MAP = {
    myBookingHeader: 'header-detail-booking',
    airportService: 'anc-airport-service',
    /** 19.3.	初期表示サービス=“seatRequest"(事前座席指定)　かつ　予約詳細(サービス)(S01-P033)にて、画面.事前座席指定情報が表示されている場合(利用可能)。*/
    // スクロール位置を予約詳細(サービス)(S01-P033)の画面.事前座席指定情報として、スクロールを行う。
    seatRequest: 'anc-seat-reservation',
    /** 19.4.	初期表示サービス=“lounge"(ラウンジ)　かつ　予約詳細(サービス)(S01-P033)にて、画面.ラウンジ情報が表示されている場合(利用可能)。*/
    // スクロール位置を予約詳細(サービス)(S01-P033)の画面.ラウンジ情報として、スクロールを行う。
    lounge: 'anc-lounge',
    /** 19.5.	初期表示サービス=“firstBaggage"(事前追加手荷物)　かつ　予約詳細(サービス)(S01-P033)にて、画面.手荷物情報が表示されている場合(利用可能) */
    // スクロール位置を予約詳細(サービス)(S01-P033)の画面.手荷物情報として、スクロールを行う。
    firstBaggage: 'anc-baggage',
    /** 19.6.	初期表示サービス=“meal"(機内食)　かつ　予約詳細(サービス)(S01-P033)にて、画面.機内食情報が表示されている場合(利用可能)。*/
    // 初期表示サービス=“meal"(機内食)　かつ　予約詳細(サービス)(S01-P033)にて、画面.機内食情報が表示されている場合(利用可能)。
    meal: 'anc-meal',
    /** 19.7.	初期表示サービス="pet"(ペットらくのり)　かつ　予約詳細(サービス)(S01-P033)にて、画面.ペットらくのり情報が表示されている場合(利用可能)。*/
    // スクロール位置を予約詳細(サービス)(S01-P033)の画面.ペットらくのり情報として、スクロールを行う。
    petRakunori: 'anc-travel-with-pet',
    /** 19.8.	初期表示サービス="myCarValet"(マイカーバレー)　かつ　予約詳細(サービス)(S01-P033)にて、画面.マイカーバレー情報が表示されている場合(利用可能)。*/
    // スクロール位置を予約詳細(サービス)(S01-P033)の画面.マイカーバレー情報として、スクロールを行う。
    myCarValet: 'anc-my-car-valet',
    /** 19.9.	初期表示サービス="juniorPilot"(ジュニアパイロット)　かつ　予約詳細(サービス)(S01-P033)にて、画面.ジュニアパイロット情報が表示されている場合(利用可能)。*/
    // スクロール位置を予約詳細(サービス)(S01-P033)の画面.ジュニアパイロット情報として、スクロールを行う。
    juniorPilot: 'anc-junior-pilot',
  };

  readonly ERROR_CODE_MAP_DEFAULT_REFUND_DELETE_ORDER: Record<string, string> = {
    /** "EBAZ000023”(解約対象PNR情報の取得に失敗) => "E0712"(予約の特定ができない旨) */
    [ErrorCodeConstants.ERROR_CODES.EBAZ000023]: 'E0712',
    /** "EBAZ000078”(解約不可) => E1141(予約が解約できない旨) */
    [ErrorCodeConstants.ERROR_CODES.EBAZ000078]: 'E1141',
  };

  // Reference from ReceiptSearchService
  showPdfInNewWindow(pdfBase64str: string, pdfName: string) {
    const pdfWindow = window.open('')!;
    this.renderPdfViewToDocument(pdfBase64str, pdfWindow.document, pdfName);
  }

  // reference from ReceiptSearchService
  renderPdfViewToDocument(pdfBase64str: string, document: Document, pdfName: string): void {
    var pdfBinary = atob(pdfBase64str);
    var pdfBuffer = new Uint8Array(pdfBinary.length);
    for (let i = 0; i < pdfBinary.length; i++) {
      pdfBuffer[i] = pdfBinary.charCodeAt(i);
    }

    const blob = new Blob([pdfBuffer], { type: 'application/pdf' });
    const url = window.URL.createObjectURL(blob);

    const embedDom = createEmbedNode(url);
    document.title = pdfName;
    document.body.append(embedDom);

    function createEmbedNode(url: string) {
      const node = document.createElement('embed');
      node.src = `${url}#toolbar=1`;
      node.style.width = '100vw';
      node.style.height = '100vh';
      return node;
    }
  }
  // reference from ReceiptSearchService
  downloadPDF(base64str: string, pdfName: string): void {
    const byteCharacters = atob(base64str);
    const byteArray = Array.from(byteCharacters, (char) => char.charCodeAt(0));
    const blob = new Blob([new Uint8Array(byteArray)], { type: 'application/pdf' });

    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = pdfName;
    link.click();
    link.remove();
  }

  /**
   * 指定した先頭または末尾のN文字のみ可視で、他をすべて * でマスクする共通関数。
   *
   * @param value - マスクしたい文字列
   * @param visibleCount - 可視にする文字数
   * @param fromEnd - 末尾を可視にする場合 true（デフォルトfalse＝先頭可視）
   */
  partialMask(value: string, visibleCount: number, fromEnd = false): string {
    if (!value) return '';
    if (value.length <= visibleCount) return '*'.repeat(value.length);

    if (fromEnd) {
      return '*'.repeat(value.length - visibleCount) + value.slice(-visibleCount);
    } else {
      return value.slice(0, visibleCount) + '*'.repeat(value.length - visibleCount);
    }
  }
  /**
   * 文字列中の数字（0-9）だけ * にするマスク関数
   */
  maskDigit(date: string): string {
    if (!date) return '';
    return date.replace(/\d/g, '*');
  }
  /**
   * PNR情報取得API応答に対してマスクを行う。
   * @param order PNR情報取得API応答
   * @returns マスクしたPNR情報取得API応答
   */
  maskOrderForStore(order: GetOrderResponseData): GetOrderResponseData {
    const masked: GetOrderResponseData = JSON.parse(JSON.stringify(order));

    // travelers
    masked.travelers?.forEach((t: any) => {
      t.dateOfBirth = this.maskDigit(t.dateOfBirth);
      // t.age = t.age ? this.partialMask(String(t.age), 0) : t.age;
      t.regulatoryDetails?.passports?.forEach((p: any) => {
        p.birthDate = this.maskDigit(p.birthDate);
        p.number = '********'; //パスポート番号は常に8桁マスク固定(APIのマスク仕様に準拠)
      });
    });

    // contacts - representative
    masked.contacts?.representative?.emails?.forEach((e: any) => {
      e.address = this.partialMask(e.address, 3);
    });
    masked.contacts?.representative?.phones?.forEach((p: any) => {
      p.number = this.partialMask(p.number, 3, true);
    });

    // contacts - upgradeNotification
    masked.contacts?.upgradeNotification?.emails?.forEach((e: any) => {
      e.address = this.partialMask(e.address, 3);
    });

    // contacts - dynamic (搭乗者ID)
    if (masked.contacts) {
      Object.keys(masked.contacts)
        .filter((key) => !['representative', 'upgradeNotification'].includes(key))
        .forEach((paxId: string) => {
          const passenger = masked.contacts![paxId];
          passenger?.emails?.forEach((e: any) => {
            e.address = this.partialMask(e.address, 3);
          });
          passenger?.phones?.forEach((p: any) => {
            p.number = this.partialMask(p.number, 3, true);
          });
          passenger?.contactEmails?.forEach((e: any) => {
            e.address = this.partialMask(e.address, 3);
          });
          passenger.secondContact.forEach((sc: any) => {
            if (sc.phones?.number) {
              sc.phones.number = this.partialMask(sc.phones.number, 3, true);
            }
          });
        });
    }

    // frequentFlyerCards (搭乗者ID動的)
    if (masked.frequentFlyerCards) {
      Object.keys(masked.frequentFlyerCards).forEach((paxId: string) => {
        const cards = (masked.frequentFlyerCards as { [key: string]: any })[paxId];
        ['fqtv', 'fqtr', 'fqts', 'fqtu'].forEach((type) => {
          cards?.[type]?.forEach?.((c: any) => {
            c.cardNumber = this.partialMask(c.cardNumber, 4, true);
          });
        });
      });
    }

    // services.juniorPilot
    if (masked.services?.juniorPilot) {
      Object.values(masked.services.juniorPilot).forEach((segment: any) => {
        Object.values(segment || {}).forEach((person: any) => {
          if (person.accompanyOnDepartureInformation?.phoneNumber) {
            person.accompanyOnDepartureInformation.phoneNumber = this.partialMask(
              person.accompanyOnDepartureInformation.phoneNumber,
              3,
              true
            );
          }
          if (person.meetingOnArrivalInformation?.phoneNumber) {
            person.meetingOnArrivalInformation.phoneNumber = this.partialMask(
              person.meetingOnArrivalInformation.phoneNumber,
              3,
              true
            );
          }
          if (person.guardianInformation?.phoneNumber) {
            person.guardianInformation.phoneNumber = this.partialMask(person.guardianInformation.phoneNumber, 3, true);
          }
        });
      });
    }

    return masked;
  }
}
